export const CASES = {
  UPDATE_PMX_DELIVERIES: "UPDATE_PMX_DELIVERIES",
  UPDATE_PMX_DELIVERIES_SEARCH_FORM: "UPDATE_PMX_DELIVERIES_SEARCH_FORM",
  CLEAR_PMX_DELIVERIES: "CLEAR_PMX_DELIVERIES",
};
